/*
 * Material 3's touch ripple, as a Svelte action. Mirrors BirdJournal.Html/app/svelte/lib/ripple.ts —
 * the same gesture on the same platform should feel the same.
 *
 * The element needs the `rip` class for the state layer and the overflow clip; this only adds the
 * expanding circle on press.
 */
export function ripple(node: HTMLElement) {
  const start = (event: PointerEvent) => {
    if (node.hasAttribute('disabled')) return

    const bounds = node.getBoundingClientRect()
    // Reach the furthest corner from the press point, so the circle always covers the element.
    const radius = Math.hypot(
      Math.max(event.clientX - bounds.left, bounds.right - event.clientX),
      Math.max(event.clientY - bounds.top, bounds.bottom - event.clientY),
    )

    const circle = document.createElement('span')
    circle.className = 'bj-ripple'
    circle.style.width = circle.style.height = `${radius * 2}px`
    circle.style.left = `${event.clientX - bounds.left - radius}px`
    circle.style.top = `${event.clientY - bounds.top - radius}px`
    node.appendChild(circle)
    circle.addEventListener('animationend', () => circle.remove())
  }

  node.addEventListener('pointerdown', start)
  return { destroy: () => node.removeEventListener('pointerdown', start) }
}
